import React from "react";
import CaseStudys from "../index";
import styles from "./styles.module.scss";
import raajpowerelectricalsbanner from "../../../assets/casestudy/raajpowerelectricalsbanner.png";
import raajpowerelectricals1img from "../../../assets/casestudy/raajpowerelectricals1img.png";
import raajpowerelectricals2img from "../../../assets/casestudy/raajpowerelectricals1img.png";
import raajpowerelectricals3img from "../../../assets/casestudy/raajpowerelectricals1img.png";

import KumarPhotography from "../../../assets/img/KumarPhotoGraphy.png";
import Mongodbicon from "../../../assets/img/mongodbicon.svg";
import Nodeicon from "../../../assets/img/nodeicon.svg";
import Reacticon from "../../../assets/img/reacticon.svg";
import Expressicon from "../../../assets/img/expressicon.svg";
import ZEEQRCaseStudy from "../../../assets/casestudy/ZEEQRCaseStudy.webp";
import Ajtech2ndimg from "../../../assets/casestudy/ajtech2ndimg.webp";

const RaajPowerElectricals = () => {
  const caseStudiesB = [
    {
      image: ZEEQRCaseStudy,
      title: "Zeeqr",
      category: "Website Design",
      pagelink: "/zeeqr",
      link: "https://zeeqr.com/",
    },
    {
      image: Ajtech2ndimg,
      title: "AJTechIndustry",
      category: "Website Design",
      pagelink: "/ajtechIndustry",
      link: "https://agtechindustries.com/",
    },
  ];
  const servicesB = [
    { label: "UI & UX Design", link: "https://metasoft.ae/services" },
    { label: "Web Development", link: "https://metasoft.ae/services" },
    { label: "Performance Optimization", link: "https://metasoft.ae/services" },
    { label: "SEO", link: "https://metasoftdm.com/marketing-solutions/seo/" },
  ];
  return (
    <CaseStudys
      title="RaajPowerElectricals"
      caseStudies={caseStudiesB}
      subtitle="Reliable Power & Electrical Infrastructure Services"
      header="Reliable Power & Electrical Infrastructure Services"
      // websiteUrl="http://www.snkollajejewellers.com/"
      industry="Electrical & Power Infrastructure Services"
      services={servicesB}
      description={
        <>
          <span>Raaj Power Electricals </span> Arya Fire & Safety is a trusted
          fire protection company committed to delivering reliable, compliant,
          and high-quality safety solutions for businesses and homes. To
          showcase their expertise and comprehensive range of products and
          services, we developed a clean and professional digital presence that
          reflects their credibility and long-standing commitment to safety. The
          website highlights their equipment, installation services, and
          training programs with clarity, offering users a smooth browsing
          experience that builds trust and makes it easy to explore and
          understand their fire safety offerings.
        </>
      }
      objective={{
        heading:
          "Developing a Modern and Informative Digital Experience for Lighting Solutions",
        content: (
          <>
            <p className={styles.projectText}>
              The objective of the Hilight Lighting Studio website project was
              to create a visually appealing and professional digital presence
              that reflects the brand’s expertise in stylish and functional
              lighting solutions. Our goal was to design a clean, organized
              platform that clearly showcases their range of lighting fixtures,
              custom designs, and installation services. This project aimed to
              communicate Hilight Lighting Studio’s credibility, highlight their
              creativity and years of industry experience, and provide users
              with a seamless browsing experience that simplifies
              discovery—ultimately helping homeowners and businesses find the
              right lighting solutions with confidence while strengthening
              engagement in a competitive interior lighting market.
            </p>
          </>
        ),
      }}
      process={{
        heading: "How We Designed a Professional and Intuitive Website",
        content: (
          <>
            <p className={styles.projectText}>
              The project started with a detailed understanding of Hilight
              Lighting Studio’s brand identity, design philosophy, and the needs
              of clients seeking innovative lighting solutions. Using these
              insights, we crafted a user journey that emphasized inspiration,
              easy exploration, and clear presentation of their diverse product
              range. In the design phase, we focused on elegant layouts,
              high-quality visuals, and intuitive navigation to reflect both
              creativity and professionalism. Development prioritized a
              responsive, fast-loading platform with seamless mobile
              performance, ensuring users could effortlessly browse fixtures,
              view installations, and access service details. Continuous
              feedback and iterative testing ensured the final website delivered
              a polished, engaging, and confidence-building experience for every
              visitor.
            </p>
          </>
        ),
      }}
      impact={{
        heading:
          "How the New Online Presence Boosted Arya Fire & Safety’s Customer Engagement",
        content: (
          <>
            <p className={styles.projectText}>
              The launch of the Arya Fire & Safety website significantly
              enhanced the brand’s digital presence, providing businesses and
              individuals with a clear and trustworthy way to explore fire
              safety solutions. The organized layout, intuitive navigation, and
              well-structured content improved user understanding while
              reinforcing confidence in the brand’s expertise and reliability.
              With faster access to product and service details, seamless mobile
              performance, and an overall smoother browsing experience, the
              website has helped increase user engagement and broaden reach
              within the fire safety market. As a result, the platform now
              serves as a professional and dependable touchpoint that supports
              informed decision-making and strengthens Arya Fire & Safety’s
              brand reputation..
            </p>
          </>
        ),
      }}
      conclusion={{
        heading: "Wrapping Up the Project",
        content: (
          <>
            <p className={styles.projectText}>
              In conclusion, the Arya Fire & Safety website effectively
              reflected the brand’s dedication to reliable, compliant, and
              professional fire protection solutions. By combining a clean,
              organized design with seamless functionality, the platform now
              serves as a powerful tool for showcasing products and services,
              building trust, and guiding users toward informed safety
              decisions. The project not only elevated the brand’s digital
              presence but also reinforced Arya Fire & Safety’s position as a
              credible and dependable partner in the competitive fire safety
              market, supporting ongoing growth and long-term industry
              leadership.
            </p>
          </>
        ),
      }}
      heroImage={raajpowerelectricalsbanner} // Add the hero image
      projectImage={raajpowerelectricals1img}
      projectImage2={raajpowerelectricals2img}
      projectImage3={raajpowerelectricals3img}
      // Add the project image
      technologies={[
        { name: "MongoDB", icon: Mongodbicon },
        { name: "Node.js", icon: Nodeicon },
        { name: "React", icon: Reacticon },
        { name: "Express.js", icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Aug 2025" // Add the launch date
    />
  );
};

export default RaajPowerElectricals;
